import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ITableModel } from '../table/model/tableModel';
import { appService } from '../../../_services/app.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { CommonService } from '../../../shared/services/commen/commen.services';
import { Helpers } from '../../../helpers';
import { NavService } from '../../../_services/NavService.service';
import { PrintReportComponent } from '../print-report/print-report.component';

@Component({
  selector: 'app-order-wave-summary',
  templateUrl: './order-wave-summary.component.html',
  styleUrls: ['./order-wave-summary.component.scss']
})
export class OrderWaveSummaryComponent implements OnInit,OnChanges {

  totalOrderCount: number = 0;
  tableDetails: ITableModel;
  userId: any;
  TenantId: any;
  CompanyId: any;
  noOfPages: number = 15;
  payload: any = {};
  @Input() SearchValue :any;
  @ViewChild(PrintReportComponent) PrintReportChild: PrintReportComponent;

  constructor(
    private _appService: appService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private commonService: CommonService,
    private _navService: NavService,
  ) { }

  ngOnInit() {
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"))
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    const storedPerPage = localStorage.getItem('perPage');
    if (storedPerPage) {
      this.noOfPages = parseInt(storedPerPage, 10);
    }

    setTimeout(() => {
      this.callTable();
      this.GetOrderList();
    }, 300);

    setTimeout(() => {
      this._navService.navItem$.subscribe((item) => {
        if (
          this.CompanyId != JSON.parse(localStorage.getItem("ChnageCompnayId")).Id 
        ) {
          this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
          this.GetOrderList();
        }
      });
    }, 500);

    console.log('ngonint .CompanyId',this.CompanyId);
  }

  ngOnChanges(changes: SimpleChanges): void {
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id; 

    if (changes.SearchValue) {
      this.GetOrderList(0, this.noOfPages);
    }

    console.log('ngOnChanges .CompanyId',this.CompanyId);
  }

  callTable(){
    this.tableDetails = {
      data: [],
      emptyDataMSg: 'No Allocate Order Found.',
      isColumnNameShow: true,
      columnDetails: [
          { columnName: "Wave No", dataFieldName: 'WaveNumber', alignType: '' },
          { columnName: "Wave Date", dataFieldName: 'WaveDate', alignType: '' },
          { columnName: "Device Name", dataFieldName: 'DeviceName', alignType: '' },
          { columnName: "From Date", dataFieldName: 'FromDate', alignType: '' },
          { columnName: "To Date", dataFieldName: 'ToDate', alignType: '' },
          { columnName: "From Order No", dataFieldName: 'FromOrderNo', alignType: '' },
          { columnName: "To Order No", dataFieldName: 'ToOrderNo', alignType: '' },
          { columnName: 'From Order Ref.No', dataFieldName: 'FromOrderReferenceNo', divType: '' },
          { columnName: 'To Order Ref.No', dataFieldName: 'ToOrderReferenceNo', divType: '' },
          { columnName: 'Total Orders', dataFieldName: 'TotalOrders', divType: '' },
          { columnName: 'Allocated Orders', dataFieldName: 'AllocatedOrders', divType: '' },
          { columnName: 'Manifested Orders', dataFieldName: 'ManifestedOrders', divType: '' },
          { columnName: 'Created By', dataFieldName: 'CreatedBy', divType: '' },
          { columnName: 'Created On', dataFieldName: 'CreatedOn', divType: '' },
          // { columnName: 'Status', dataFieldName: 'AllocateStatus', DynamicColor:'StatusColorCode', divType: 'WaveSummaryStatus' },
          { columnName: "Actions", dataFieldName: '', divType: 'action' },
      ],
      actionList: [
        { label: 'Download Report' },
        { label: 'Print Invoice & Pick Slip' },
        { label: 'Print Pick Summary'},
      ],
    };
  }

  assignTableFields(pageNo:any, perPage:any, data:any) {
    this.tableDetails = {
      ...this.tableDetails, 
      paginationDetails: {
        totalItems: this.totalOrderCount,
        itemsPerPage: perPage,
        currentPage: pageNo + 1
      },
      data: data
    }
  }

  onPageChange(pageNo: number) {
    const storedPerPage = localStorage.getItem('perPage') || this.noOfPages;
    this.GetOrderList(pageNo - 1,storedPerPage);
  }

  onPageNumberChange(noOfPages: any) {
    localStorage.setItem('perPage',noOfPages);
    this.noOfPages = noOfPages
    this.GetOrderList(0,noOfPages);
  }

  onActionClick({ row, actionName, index }:any) {
    if (actionName.trim() == 'Download Report') {
      this.DownloadWaveReport(row.Id,row.WaveNumber); 
    } else if (actionName.trim() == 'Print Pick Summary'){
      this.GetOutwardIdsByWave(row.Id,row.WaveNumber,this.CompanyId,'Print Pick Summary');
    } else if (actionName.trim() == 'Print Invoice & Pick Slip'){
      this.GetOutwardIdsByWave(row.Id,row.WaveNumber,this.CompanyId,'Print Invoice & Pick Slip');
    }
  }

  GetOrderList(
    pageNo: number = 0, 
    perPage: any = this.noOfPages
  ) {
    
    Helpers.setLoading(true);
    localStorage.setItem('perPage', perPage);
    this.payload.Start = pageNo * perPage;
    this.payload.Length = perPage;
    this.payload.CompanyId = this.CompanyId;
    this.payload.UserId = this.userId;
    this.payload.SearchValue  = this.SearchValue;

    this._appService.Post("so_GoodsOutward", "WaveOrderSummaryList", this.payload).subscribe(
      (response) => {
        if (response.length) {
          this.totalOrderCount = response[0].recordcount;
        } else {
          this.totalOrderCount = 0;
        }
        this.assignTableFields(pageNo, perPage, response);
        Helpers.setLoading(false);
      },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error(err._body.replace(/"/g, ""), "Error");
      }
    );
  }

  // DownloadWaveReport(Id:any,waveNo:any) {
  //   Helpers.setLoading(true);
  //   this._appService.GetByThreeId("so_GoodsOutward", "DownloadWaveSummaryRept", Id,waveNo, this.CompanyId).subscribe(
  //     (response) => {
  //       this.DownloadFile(response);
  //       Helpers.setLoading(false);
  //     },
  //     (err) => {
  //       this.toastr.error(err._body.replace(/"/g, ""), "error");
  //       Helpers.setLoading(false);
  //     }
  //   );
  // }

  DownloadWaveReport(Id: any, waveNo: any) {
    Helpers.setLoading(true);
    let payload: any = {
      WaveId: Id,
      WaveNumber: waveNo,
      CompanyId: this.CompanyId,
      Start: null,
      Length: null
    };

    this._appService.Post("so_GoodsOutward", "DownloadWaveSummaryRept", payload).subscribe(
      (response) => {
        this.DownloadFile(response);
        Helpers.setLoading(false);
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
        Helpers.setLoading(false);
      }
    );
  }

  DownloadFile(FileContent) {
    var byteNumbers = new Array(FileContent.Content.length);
    for (var i = 0; i < FileContent.Content.length; i++) {
      byteNumbers[i] = FileContent.Content.charCodeAt(i);
    }
    var blob = this.commonService.b64toBlob(FileContent.Content, FileContent.ContentType);
    let url = window.URL.createObjectURL(blob);
    $("#DownLoadFileTyreReport").attr('href', url);
    $("#DownLoadFileTyreReport").attr('download', FileContent.FileName);
    let element: HTMLElement = document.getElementById("DownLoadFileTyreReport") as HTMLElement;
    element.attributes
    element.click();
  }

  GetOutwardIdsByWave(Id:any,WaveNo:any,CompanyId:any,Type:any){
    this._appService.GetById('so_GoodsOutward','GetOutwardIdsByWave',Id).subscribe(
      (res)=>{
        if(res && res.length > 0){
            
          var selectedOrderIds = res
          .filter((x: any) => x.OrderId != null && x.OrderId.toString().trim() !== '')
          .map((x: any) => x.OrderId);

          if (selectedOrderIds.length === 0) {
            this.toastr.warning("There are no orders available for printing.", "Warning");
            return;
          }

          if(Type === 'Print Pick Summary'){
            this.PrintReportChild.CompanyId = CompanyId;
            this.PrintReportChild.OrderId = selectedOrderIds.join(',');
            this.PrintReportChild.ParentUserId = this.userId;
            this.PrintReportChild.ReportType = "Print Outward Summary Pick";
            this.PrintReportChild.PrintInvoice();
          } else if (Type === 'Print Invoice & Pick Slip'){
            this.PrintReportChild.CompanyId = CompanyId;
            this.PrintReportChild.OrderId = selectedOrderIds.join(',');
            this.PrintReportChild.ParentUserId = this.userId;
            this.PrintReportChild.ReportType = "Print Goods Outward Invoice And Pick Slip";
            this.PrintReportChild.callPrintMethod();
          }

        }else{
          this.toastr.warning("There are no orders available for printing.", "Warning");
        }
      },
      (err)=>{
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    )
  }
}